import * as ex from "excalibur";
import { Resources } from "../Resources";
import { Player } from "../player";
import { Grandpa } from "../actors/characters/grandpa";

import { goToScene } from "../main";
import FarmerJackson from "../actors/characters/farmerJackson";
import { playerState } from "../state/stateManager";

export class Jacksons extends ex.Scene {
  constructor() {
    super();
    const player = new Player(8 * 16, 20 * 16);
    // this.backgroundColor = ex.Color.fromHex("#010101");
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 5;
    this.jackson = new FarmerJackson(
      { x: 24 * 16, y: 5 * 16 },
      "jacksonsHouse"
    );
  }
  onInitialize(engine) {
    Resources.BillsMap.addToScene(this);

    this.player.lastDir = "up";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);

    this.player.wearingVeil = false;
    // this.player = Resources.HouseMap.getObjectsByName("player");
    this.camera.zoom = 1;

    // this.camera.strategy.lockToActor(this.player);
    this.door = new ex.Trigger({
      pos: new ex.Vector(37 * 16, 10 * 16),
      width: 16,
      height: 45,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("crossroads", { x: 3 * 16, y: 10 * 16 });
      },
    });

    this.add(this.door);

    this.houseDoor = new ex.Trigger({
      pos: new ex.Vector(32 * 16, 8 * 16 + 8),
      width: 16,
      height: 45,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("jacksonsHouse", { x: 20 * 16, y: 17 * 16 });
      },
    });

    this.add(this.houseDoor);
    this.player.on("collisionstart", (e) => {
      this.interacting = e.other.owner.name;
    });
    this.player.on("collisionend", (e) => {
      this.interacting = null;
    });
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
      this.player.lastDir = data.data.direction;
    }
    let content = playerState.getContent();
    if (content.npcLocations.jackson.location == 0) {
      this.add(this.jackson);
    }
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
      if (this.interacting !== null) {
        this.jackson.startInteraction(this.player.lastDir, this.player);
      }
    }
  }
}
